import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ListaService } from '../../../_services/lista.service';
import { ConfirmationService } from 'primeng/api';
import { NavService } from '../../../_services/_nav.service';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { Table } from 'primeng/table';
import { Campania } from '../../../_models/campania';
import { Funcionalidad } from '../../../_models/funcionalidad';
import { CampaniaDescuentoMora } from '../../../_models/campania-descuento-mora';
import { CampaniaDescuentoMoraService } from '../../../_services/campania-descuento-mora.service';

@Component( {
  selector: 'app-campania-descuento-mora',
  templateUrl: 'campania-descuento-mora.component.html'
} )

export class CampaniaDescuentoMoraComponent implements OnInit {

  @Input() campania: Campania;
  formulario: FormGroup;
  campaniaDescuentoMora: CampaniaDescuentoMora;

  /** Listas */
  lisCampaniasDescuentoMora: CampaniaDescuentoMora[] = [];

  columnas: any[] = [];
  carInformacionInicial = true;
  tabSeleccionado = 'VARIABLE';
  submitted = false;
  guardando = false;
  carTabla = true;
  @ViewChild('dt') tabla: Table;
  menu: Funcionalidad = new Funcionalidad();


  constructor(
    private conServicio: ConfirmationService,
    private fb: FormBuilder,
    private serCampaniaDescuentoMora: CampaniaDescuentoMoraService,
    private route: ActivatedRoute,
    private lisServicio: ListaService,
    private navServicio: NavService,
    private router: Router,
    private autServicio: AutenticacionService
  ) {
  }

  ngOnInit() {

    if ( this.campania && (this.campania.idCampania !== null && this.campania.idCampania !== '' && this.campania.idCampania !== undefined) ) {
      /** Se carga las campanias */
      this.serCampaniaDescuentoMora.obtenerPorCampania( this.campania.idCampania ).subscribe( registros => {
        this.lisCampaniasDescuentoMora = registros;
        this.cargarInformacionInicial();
      } );
    }

  }

  cargarInformacionInicial() {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/campania' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'diaMinMora', header: this.navServicio.buscarMensaje( 'CAMPANIADCTODESTINO.LBL_DIAMINMORA' ), sort: true },
      { field: 'diaMaxMora', header: this.navServicio.buscarMensaje( 'CAMPANIADCTODESTINO.LBL_DIAMAXMORA' ), sort: true },
      { field: 'descuentoTasa', header: this.navServicio.buscarMensaje( 'CAMPANIADCTODESTINO.LBL_DESCUENTOTASA' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.cargarFormulario();

    this.carTabla = false;
    this.carInformacionInicial = false;

  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idCampaniaDescuentoDiaMora: [ this.campaniaDescuentoMora ? this.campaniaDescuentoMora.idCampaniaDescuentoDiaMora : null ],
      idCampania: [ this.campania ? this.campania.idCampania : null, [ Validators.required ] ],
      diaMinMora: [ this.campaniaDescuentoMora ? this.campaniaDescuentoMora.diaMinMora : null, [ Validators.required ] ],
      diaMaxMora: [ this.campaniaDescuentoMora ? this.campaniaDescuentoMora.diaMaxMora : null, [ Validators.required ] ],
      descuentoTasa: [ this.campaniaDescuentoMora ? this.campaniaDescuentoMora.descuentoTasa : null, [ Validators.required ] ],
      indicadorSuma: [ this.campaniaDescuentoMora ? this.campaniaDescuentoMora.indicadorSuma : false, [ Validators.required ] ],
      indicadorHabilitado: [ this.campaniaDescuentoMora ? this.campaniaDescuentoMora.indicadorHabilitado : true, [ Validators.required ] ]
    } );
  }


  get f() {
    return this.formulario.controls;
  }

  recargarCampaniasDescuento() {
    this.carTabla = true;
    this.lisCampaniasDescuentoMora = [];
    /** Se carga las campanias */
    this.serCampaniaDescuentoMora.obtenerPorCampania( this.campania.idCampania ).subscribe( registros => {
      this.lisCampaniasDescuentoMora = registros;
      this.carTabla = false;
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      this.carTabla = true;
      const formulario = this.formulario.getRawValue();
      /** se obtienen los valores del rango */
      const min = Number( formulario.diaMinMora );
      const max = Number( formulario.diaMaxMora );
      if ( formulario.idCampaniaDescuentoDiaMora ) {
        /** actualizacion del registro */
        const mismoRango = this.lisCampaniasDescuentoMora.find( x => x.idCampaniaDescuentoDiaMora === formulario.idCampaniaDescuentoDiaMora );
        /** se valida si va a actualizar solo el descuento tasa */
        if ( mismoRango && (mismoRango.diaMinMora === Number( formulario.diaMinMora ) && mismoRango.diaMaxMora === Number( formulario.diaMaxMora )) ) {
          this.actualizarRegistro( formulario );
        } else {
          /** se valida el rango */
          if ( this.validarRango( min, max, formulario.idCampaniaDescuentoDiaMora ) ) {
            /** Se actualiza normal */
            this.actualizarRegistro( formulario );
          } else {
            this.finalizarGuardado( false );
            this.navServicio.setMesage( 0, {
              severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'CAMPANIADCTODESTINO.MSG_ERRORRANGO' )
            } );
          }
        }
      } else {
        /** creacion del registro */
        if ( this.validarRango( min, max ) ) {
          /** si el rango es valido se valida si ya existe el mismo rango en un registro inhabilitado y si es asi se habilita el registro */
          const existeInhabilitado = this.lisCampaniasDescuentoMora.find( y => min === y.diaMinMora && max === y.diaMaxMora && !y.indicadorHabilitado );
          if ( existeInhabilitado && (existeInhabilitado.idCampaniaDescuentoDiaMora !== '' && existeInhabilitado.idCampaniaDescuentoDiaMora !== null && existeInhabilitado.idCampaniaDescuentoDiaMora !== undefined) ) {
            formulario.idCampaniaDescuentoDiaMora = existeInhabilitado.idCampaniaDescuentoDiaMora;
            this.actualizarRegistro( formulario, true );
          } else {
            this.guardarRegistro( formulario );
          }
        } else {
          this.finalizarGuardado( false );
          this.navServicio.setMesage( 0, {
            severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'CAMPANIADCTODESTINO.MSG_ERRORRANGO' )
          } );
        }
      }

    }
  }

  actualizarRegistro( formulario: any, guardar?: boolean ) {
    this.serCampaniaDescuentoMora.actualizar( formulario ).subscribe( regAct => {
      this.recargarCampaniasDescuento();
      this.finalizarGuardado( true );
      this.navServicio.setMesage( 0, {
        severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( (guardar === true) ? 'CAMPANIADCTODESTINO.MSG_REGCREA' : 'CAMPANIADCTODESTINO.MSG_REGACTU' )
      } );
    } );
  }

  guardarRegistro( formulario: any ) {
    this.serCampaniaDescuentoMora.crear( formulario ).subscribe( reg => {
      this.recargarCampaniasDescuento();
      this.finalizarGuardado( true );
      this.navServicio.setMesage( 0, {
        severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'CAMPANIADCTODESTINO.MSG_REGCREA' )
      } );
    } );
  }

  validarRango( min: number, max: number, idActualizando?: string ) {
    let valido = true;
    if ( min < max ) {
      if ( this.lisCampaniasDescuentoMora.length > 0 ) {
        this.lisCampaniasDescuentoMora.map( ( s: CampaniaDescuentoMora ) => {
          if ( idActualizando && (idActualizando !== '' && idActualizando !== null && idActualizando !== undefined) ) {
            if ( ((min >= s.diaMinMora && min <= s.diaMaxMora) || (max >= s.diaMinMora && max <= s.diaMaxMora)) && s.indicadorHabilitado && s.idCampaniaDescuentoDiaMora !== idActualizando ) {
              valido = false;
            } else if ( min < s.diaMinMora && s.diaMaxMora < max && s.indicadorHabilitado ) {
              valido = false;
            }
          } else {
            if ( ((min >= s.diaMinMora && min <= s.diaMaxMora) || (max >= s.diaMinMora && max <= s.diaMaxMora)) && s.indicadorHabilitado ) {
              valido = false;
            } else if ( min < s.diaMinMora && s.diaMaxMora < max && s.indicadorHabilitado ) {
              valido = false;
            }
          }
        } );
      }
    } else {
      valido = false;
    }
    return valido;
  }

  finalizarGuardado( recargar: boolean ) {
    if ( recargar ) {
      this.campaniaDescuentoMora = null;
      this.formulario.reset();
      this.cargarFormulario();
    }
    this.guardando = false;
    this.carTabla = false;
    this.submitted = false;
  }

  editar( reg: CampaniaDescuentoMora ) {
    this.campaniaDescuentoMora = reg;
    this.formulario.reset();
    this.cargarFormulario();
  }

  eliminar( item: CampaniaDescuentoMora ) {
    item.indicadorHabilitado = false;
    this.serCampaniaDescuentoMora.actualizar( item ).subscribe( regAct => {
      this.lisCampaniasDescuentoMora.map( ( s: CampaniaDescuentoMora ) => {
        if ( item.idCampaniaDescuentoDiaMora === s.idCampaniaDescuentoDiaMora ) {
          s.indicadorHabilitado = false;
        }
      } );
      this.navServicio.setMesage( 0, {
        severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'CAMPANIADCTODESTINO.MSG_REGELIM' )
      } );
    } );
  }

  obtenerCampaniasDescuentoHabilitadas() {
    return this.lisCampaniasDescuentoMora.filter( x => x.indicadorHabilitado );
  }

}
